import { IQuestionnaire } from 'src/shared/types/Case';
import { AidiProgressStatus } from 'src/utils/hooks/useAidiAccess';

/**
 * Derives a questionnaire's AIDI form-completion state from the questionnaire record itself
 * (independent of the case-level AIDI stage record, which reflects whether AIDI has any progress
 * on the case at all, not this specific questionnaire's completion state).
 */
export const getQStatusFromQuestionnaire = (q: IQuestionnaire): AidiProgressStatus => {
  if (q.isComplete === true) {
    return AidiProgressStatus.COMPLETED;
  }

  const normalizedStatus = q.questionnaireStatus?.trim().toLowerCase() ?? '';

  if (normalizedStatus === 'completed') {
    return AidiProgressStatus.COMPLETED;
  }

  if (normalizedStatus === 'not started' || normalizedStatus === 'not_started') {
    return AidiProgressStatus.IDLE;
  }

  if (
    normalizedStatus === 'in_progress' ||
    normalizedStatus === 'in progress' ||
    normalizedStatus === 'started' ||
    normalizedStatus === 'started, incomplete'
  ) {
    return AidiProgressStatus.IN_PROGRESS;
  }

  return AidiProgressStatus.IDLE;
};

/**
 * Builds the AIDI route for a given questionnaire status. When `useUrlCaseId` is enabled (the
 * `fnx-show-backtodocuments` flag), the caseId is embedded directly in the path; otherwise AIDI
 * resolves the active case from its own session state.
 */
export const getAidiCasePath = (
  caseId: number | undefined,
  qStatus: AidiProgressStatus,
  useUrlCaseId: boolean
): string => {
  const isIdle = qStatus === AidiProgressStatus.IDLE;
  if (useUrlCaseId) {
    return isIdle ? `/aidi/case/${caseId}/welcome` : `/aidi/case/${caseId}`;
  }
  return isIdle ? `/aidi/case/welcome` : `/aidi/case`;
};
